<div class="card">
  <div class="d-flex row mb-3">
    <div class="col-sm">
      <h1 class="content-header-title my-0">{{ title | abpLocalization }}</h1>
    </div>
    <div class="col-sm d-flex justify-content-sm-end justify-content-start">
      <button
        *abpPermission="'ReturnLy.Addresses.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
        >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ '::NewAddress' | abpLocalization }}
      </button>
    </div>
  </div>

  <div class="addresses-container">
    @for (address of addresses(); track address) {
      <div class="address-container">
        @if (address?.isDefault) {
          <span class="default-badge">
            {{ '::DefaultAddress' | abpLocalization }}
          </span>
        }
        <div class="actions-dropdown" container="body" ngbDropdown>
          <button
            aria-haspopup="true"
            class="btn-dropdown btn-outline"
            data-toggle="dropdown"
            ngbDropdownToggle
            >
            <i class="fas fa-ellipsis-h"></i>
          </button>
          <div ngbDropdownMenu>
            <button
              (click)="setDefault(address, this)"
              *abpPermission="'ReturnLy.Addresses.Edit'"
              [disabled]="address?.isDefault"
              ngbDropdownItem
              >
              {{ '::SetAsDefault' | abpLocalization }}
            </button>
            <button
              (click)="update(address)"
              *abpPermission="'ReturnLy.Addresses.Edit'"
              ngbDropdownItem
              >
              {{ 'AbpUi::Edit' | abpLocalization }}
            </button>
            <button
              (click)="delete(address, this)"
              *abpPermission="'ReturnLy.Addresses.Delete'"
              ngbDropdownItem
              >
              {{ 'AbpUi::Delete' | abpLocalization }}
            </button>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::FullName' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.fullName }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::PhoneNumber' | abpLocalization }}
            </div>
            <div class="property-value phoneNumber">
              {{ address?.phoneNumber }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::Country' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.country }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::City' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.city }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::State' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.state }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::StreetName' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.streetName }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::Postcode' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.postcode }}
            </div>
          </div>
        </div>
        <div class="property-item">
          <div class="step-info">
            <div class="property-step">
              {{ '::FullAddress' | abpLocalization }}
            </div>
            <div class="property-value">
              {{ address?.fullAddress }}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (isLoading()) {
    <div>
      @for (_ of [].constructor(1); track $index) {
        <div class="shimmer-item">
          <div class="shimmer"></div>
        </div>
      }
    </div>
  }
  @if (!addresses()?.length && !isLoading()) {
    <div>{{ '::NotFound' | abpLocalization }}</div>
  }
</div>
@defer(when serviceDetail.isVisible()) {
<app-address-detail-modal
  [refreshAdresses]="refreshAdresses.bind(this)"
  [isVisible]="serviceDetail.isVisible()"
  [currentUser]="currentUser()" />
}
